/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ClockIn/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ClockIn({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ClockIn",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2
  
}) {
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let fill2OrdtColorsBlack = fill2 ?? dtColorsBlack
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ClockIn.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-LQHWV': alignSelf,'--mt-2-LQHWV': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-LQHWV': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-LQHWV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-LQHWV': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-LQHWV': opacity,'--w-10-LQHWV': typeof width === 'number' ? `${width}px` : width,'--h-11-LQHWV': typeof height === 'number' ? `${height}px` : height,'--f-12-LQHWV': fill,'--a-7-LQHWV': isAnimated ? animation : "none",'--sd-8-LQHWV': isAnimated ? strokeDashoffset : 0,'--sd-9-LQHWV': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ClockIn.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8.429 3.429a1.429 1.429 0 00-2.858 0v1.428H4.143C2.959 4.857 2 5.817 2 7v12.857C2 21.041 2.96 22 4.143 22h15.714C21.041 22 22 21.04 22 19.857V7c0-1.183-.96-2.143-2.143-2.143H18.43V3.43a1.429 1.429 0 00-2.857 0v1.428H8.429V3.43zm7.949 7.847a1.072 1.072 0 00-1.613-1.41l-4.246 4.853-1.333-1.334a1.071 1.071 0 10-1.515 1.514l2.142 2.145a1.071 1.071 0 001.565-.052l5-5.716z"
 style={{'--f-12-LQHWV': fill2OrdtColorsBlack}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}